/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    IGeoMatch,
    MatchOperation,
} from 'generated-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { GeoMatch } from 'object-types';

/**
 * @description  GeoMatch ConfigItem class.
 * @author Nisar Nadaf
 */
export class GeoMatchConfigItem extends MessageItem<IGeoMatch> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: GeoMatch,
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    public get defaultConfigOverride_(): Partial<IGeoMatch> {
        const defaultValues = this.getAjsDependency_('defaultValues');
        const defaultConfig = defaultValues.getDefaultItemConfigByType(this.objectType) || {};

        return {
            ...defaultConfig,
            match_operation: MatchOperation.IS_IN,
        };
    }
}
